<template>
  <div>
    <div v-if="!isLoad">
      <!-- <v-app> -->
      <v-main class="bg-[#F7FAFB] dark-bg-default" style="padding: 0px">
        <v-col>
          <v-tabs 
            v-model="tabs" 
            align-with-title 
            :color="$vuetify.theme.currentTheme.primary">
            <v-tab
              :ripple="false"
              v-for="(tab, index) in tabItems"
              :key="index"
              class="mr-12 ml-0"
              :color="$vuetify.theme.currentTheme.primary"
            >
              {{ tab.name }}
            </v-tab>
            <v-tabs-slider color="#32D583"></v-tabs-slider>
          </v-tabs>
        </v-col>
        <component :is="currentTab"></component>
      </v-main>
      <!-- </v-app> -->
    </div>
    <div
      v-else
      class="absolute w-full h-screen flex-col items-center flex justify-center"
    >
      <v-progress-circular
        :color="$vuetify.theme.currentTheme.primary"
        indeterminate
        :size="50"
        :width="5"
      ></v-progress-circular>
      <div class="mt-2"><span>Please Wait...</span></div>
    </div>
  </div>
</template>

<script>
import Roles from "~/components/Workforce/Settings/Roles.vue";
import Configurations from "~/components/Workforce/Settings/Configurations.vue";

export default {
  name: "SettingsPage",
  layout: "Workforce/default",
  components: {
    Roles,
    Configurations,
  },
  data() {
    return {
      tabs: 0,
      tabItems: [
        { key: "roles", name: "Roles", component: "Roles" },
        {
          key: "configurations",
          name: "Configurations",
          component: "Configurations",
        },
      ],
      isLoad: true,
    };
  },
  methods: {},
  computed: {
    currentTab() {
      return this.tabItems[this.tabs]?.component;
    },
  },
  mounted() {
    this.isLoad = false;
    const config = this.$route.query?.settings_tab;
    const savedTab = localStorage.getItem("settingActiveTab");
    if (savedTab) {
      this.tabs = 1;
    }
    if (config) {
      this.tabs = this.tabItems.findIndex((tab) => tab.key === config);
    }
  },
};
</script>

<style scoped>
.v-tab:before {
  background-color: transparent;
}

.v-tab {
  font-size: 16px;
}
</style>
